import React, { Component } from 'react';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { flattenMessages } from '@utils/languageUtils';
import { IntlProvider } from 'react-intl';
import { getUserLang } from '@utils/localeUtils';
import ptBR from './i18n/ptBR';
import enUS from './i18n/enUS';
import esES from './i18n/esES';
import CardIcon from '@components/CardIcon/CardIcon';
import Grid from '@material-ui/core/Grid';
import TextField from '@components/TextFieldOwn/TextFieldOwn';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import ButtonFABMenu from '@components/ButtonFABMenu/ButtonFABMenu';
import CircularProgress from '@material-ui/core/CircularProgress';
import swal from '@sweetalert/with-react';
import Loading from '@components/Loading/Loading';
import Especie from '@resources/Especie';
import Checkbox from '@material-ui/core/Checkbox';

let messages = { 'pt-BR': ptBR, 'en-US': enUS, 'es-ES': esES };

const iconMenuPontos = require('@images/icone_fab_menu.png');

let { provider } = new IntlProvider({});

const style = () => ({
  switch: {
    height: 70,
    display: 'flex',
    alignItems: 'center',
    marginLeft: -15,
    cursor: 'pointer'
  },
  card: {
    width: '100%',
    height: '100%'
  },
  cardGrid: {
    width: '100%',
    height: '100%',
    marginTop: 23
  },
  font: {
    fontSize: 14,
    width: '100%',
    writeSpace: 'noWrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing.unit * 27.5,
    right: theme.spacing.unit * 3.7,
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    zIndex: 1,
    marginBottom: 0
  }
});

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#00622B',
      main: '#00622B',
      dark: '#00622B',
      contrastText: '#fff'
    }
  },
  typography: {
    useNextVariants: true
  }
});

/**
 * Componente de edição de espécie
 *
 * @author Gabriela Farias
 * @class EditarEspecie
 * @extends {Component} - Componente React
 */
class EditarEspecie extends Component {
  constructor(props) {
    super(props);

    const messagesLinguage = flattenMessages(messages[getUserLang()]);
    const especieCadastradaComSucesso = messagesLinguage['especie.especieCadastradaComSucesso'];
    const especieEditadaComSucesso = messagesLinguage['especie.especieEditadaComSucesso'];
    const falhaAoEditarEspecie = messagesLinguage['especie.falhaAoEditarEspecie'];
    const falhaAoCadastrarEspecie = messagesLinguage['especie.falhaAoCadastrarEspecie'];
    const falhaAoCarregarEspecie = messagesLinguage['especie.falhaAoCarregarEspecie'];
    const salvar = messagesLinguage['especie.salvar'];
    const cancelar = messagesLinguage['especie.cancelar'];
    const salvando = messagesLinguage['especie.salvando'];
    const atualizando = messagesLinguage['especie.atualizando'];
    const campoObrigatorio = messagesLinguage['especie.campoObrigatorio'];
    const identificacao = messagesLinguage['especie.identificacao'];
    const descricao = messagesLinguage['especie.descricao'];

    const intlProvider = new IntlProvider(
      {
        locale: getUserLang(),
        messages: {
          especieCadastradaComSucesso,
          especieEditadaComSucesso,
          falhaAoEditarEspecie,
          falhaAoCadastrarEspecie,
          falhaAoCarregarEspecie,
          salvar,
          cancelar,
          salvando,
          atualizando,
          campoObrigatorio,
          identificacao,
          descricao
        }
      },
      {}
    );
    provider = intlProvider.getChildContext();

    this.state = {
      checked: true,
      nmEspecie: '',
      loading: this.props.match.params.id !== undefined,
      idEspecie: ''
    };

    const title = 'especie.cadastroDeEspecie';
    if (this.props.itensState.name !== title) {
      this.props.dispatch({
        type: 'UPDATE_TOOLBAR',
        toolbar: (
          <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
            <FormattedMessage id={title} />
          </IntlProvider>
        ),
        name: title
      });
    }

    this.clickCadastrarEditar = this.clickCadastrarEditar.bind(this);
    this.clickCancelar = this.clickCancelar.bind(this);
    this.iniciarAtributosEdicao = this.iniciarAtributosEdicao.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.iniciarAtributosEdicao();
    }
  }

  iniciarAtributosEdicao() {
    Especie.findEspecieById(this.props.match.params.id)
      .then(query => {
        this.setState({
          nmEspecie: query.data.dsEspecieAnimal,
          loading: false,
          idEspecie: query.data.idEspecieAnimal,
          checked: query.data.stEspecieAnimal ? true : false
        });
      })
      .catch(error => {
        this.setState({
          loading: false
        });
        swal(provider.intl.formatMessage({ id: 'falhaAoCarregarEspecie' }), {
          icon: 'error',
          buttons: {
            confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              closeModal: true,
              className: 'swal2-error'
            }
          }
        });
      });
  }

  clickCadastrarEditar(values) {
    if (!this.state.validarInputs) {
      swal(
        <div>
          <MuiThemeProvider theme={theme}>
            <CircularProgress />
          </MuiThemeProvider>
        </div>,
        {
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          title: provider.intl.formatMessage({
            id: this.props.match.params.id === undefined ? 'salvando' : 'atualizando'
          })
        }
      );

      const data = {
        dsEspecieAnimal: values.nmEspecie,
        stEspecieAnimal: this.state.checked ? 1 : 0
      };

      if (this.props.match.params.id === undefined) {
        Especie.addEspecie(data)
          .then(query => {
            swal(
              provider.intl.formatMessage({
                id: 'especieCadastradaComSucesso'
              }),
              {
                icon: 'success',
                buttons: {
                  confirm: {
                    text: 'Ok',
                    value: true,
                    visible: true,
                    closeModal: true,
                    className: 'swal2-Ok'
                  }
                }
              }
            ).then(() => {
              this.clickCancelar();
            });
          })
          .catch(error => {
            swal(provider.intl.formatMessage({ id: 'falhaAoCadastrarEspecie' }), {
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-error'
                }
              }
            });
          });
      } else {
        data.idEspecieAnimal = this.props.match.params.id;

        Especie.editEspecie(data)
          .then(query => {
            swal(provider.intl.formatMessage({ id: 'especieEditadaComSucesso' }), {
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-Ok'
                }
              }
            }).then(() => {
              this.clickCancelar();
            });
          })
          .catch(error => {
            swal(provider.intl.formatMessage({ id: 'falhaAoEditarEspecie' }), {
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-error'
                }
              }
            });
          });
      }
    }
  }

  clickCancelar() {
    this.props.history.push('/app/especie');
  }

  render() {
    const { classes } = this.props;
    return (
      <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
        <Formik
          initialValues={{
            nmEspecie: this.state.nmEspecie
          }}
          onSubmit={this.clickCadastrarEditar}
          validateOnBlur
          enableReinitialize={true}
          validateOnChange={false}
          validationSchema={Yup.object().shape({
            nmEspecie: Yup.string().required(provider.intl.formatMessage({ id: 'campoObrigatorio' }))
          })}
          render={({
            values,
            handleSubmit,
            errors,
            touched,
            handleBlur,
            setFieldValue,
            handleChange
          }) => (
            <MuiThemeProvider theme={theme}>
              <form className={classes.card} autoComplete='off'>
                {this.state.loading && <Loading />}
                <CardIcon titulo={provider.intl.formatMessage({ id: 'identificacao' })}>
                  <div className={classes.cardGrid}>
                    <Grid container spacing={16}>
                      <Grid item xs={4}>
                        <TextField
                          label={provider.intl.formatMessage({ id: 'descricao' })}
                          name='nmEspecie'
                          value={values.nmEspecie}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.nmEspecie && touched.nmEspecie}
                          helperText={errors.nmEspecie && touched.nmEspecie ? errors.nmEspecie : null}
                          style={{ width: '100%', height: 70 }}
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <div
                          className={classes.switch}
                          onClick={() => this.setState({ checked: !this.state.checked })}
                        >
                          <Checkbox
                            checked={this.state.checked}
                            value='stEspecieAnimal'
                            color='primary'
                          />
                          <label style={{ color: '#000000' }}>
                            <FormattedMessage id='especie.ativo' />
                          </label>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </CardIcon>
                <div className={classes.fab}>
                  <ButtonFABMenu
                    icon={iconMenuPontos}
                    actions={[
                      {
                        icon: <Check style={{ color: '#FFFFFF' }} />,
                        name: provider.intl.formatMessage({ id: 'salvar' }),
                        onClickIcon: handleSubmit,
                        color: '#42ADE8'
                      },
                      {
                        icon: <Close style={{ color: '#FFFFFF' }} />,
                        name: provider.intl.formatMessage({ id: 'cancelar' }),
                        onClickIcon: this.clickCancelar,
                        color: '#F33A30'
                      }
                    ]}
                    onClickButton={this.clickAdicionar}
                  />
                </div>
              </form>
            </MuiThemeProvider>
          )}
        />
      </IntlProvider>
    );
  }
}
const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

let enhaced = withStyles(style)(EditarEspecie);
export default withRouter(connect(mapStateToProps)(enhaced));
